import { useAtomValue } from 'jotai';
import { clientConfigFieldsAtom } from '../services/state/AppConfigStateJ';

export function useIsCollectionOnly(): boolean {
  const clientConfig = useAtomValue(clientConfigFieldsAtom);
  return clientConfig?.Collection_Only === true;
}
